module.exports = __webpack_public_path__ + "media/images/soar/site/gmail-4f3ad37b856ad95dbfabe2d5794fc2ef.svg";